import fileDownload from 'js-file-download';
import { change } from 'redux-form';
import _ from 'lodash';

import { resetUploadProgress } from 'Common/UI/state/actions';
import { loading, error, success } from 'State/actions';
import { ImportExportItemsEnum } from 'Common/FieldEnum';
import { base64ToBlob } from 'Common/IEHelper';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';
import {
  IMPORT_ITEMS_FORM_NAME,
  EXPORT_ITEMS_FORM_NAME,
} from 'Common/FormEnum';
import { ImportExportTypeOptionsEnum } from 'Common/Constants/Enumeration/ImportExportInventoryEnum';

import * as types from './types';

export const postImportItemsFile = formData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SET_IMPORT_ITEMS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericFile(
        'import',
        formData,
        dispatch
      );
      dispatch(success(types.SET_IMPORT_ITEMS, response.data));
    } catch (ex) {
      dispatch(error(types.SET_IMPORT_ITEMS_LOADING_ERROR, ex));
    } finally {
      dispatch(resetUploadProgress());
      dispatch(loading(types.SET_IMPORT_ITEMS_LOADING, false));
    }
  };
};
export const clearImportItemsData = () => {
  return {
    type: types.CLEAR_IMPORT_ITEMS_DATA,
  };
};
export const clearErrorMsgs = () => {
  return {
    type: types.CLEAR_ERROR_SUCCESS,
  };
};
export const addColumnMapping = payload => {
  return {
    type: types.ADD_ITEM_COLUMN_MAPPING,
    payload,
  };
};
export const getColumns = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_COLUMNS_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `ImportExportItems/GetExportColumns`
      );
      dispatch(
        success(
          types.SET_COLUMNS,
          _.has(response, 'data.Data.Data')
            ? _.sortBy(response.data.Data.Data, ['ColLabel'])
            : []
        )
      );
    } catch (err) {
      dispatch(error(types.FETCH_COLUMNS_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.FETCH_COLUMNS_LOADING, false));
    }
  };
};
export const getExistingExportConfig = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_EXISTING_EXPORT_CONFIG_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `ImportExportItems/GetExistingImportExportConfig/true`
      );
      dispatch(
        success(
          types.SET_EXISTING_EXPORT_CONFIG,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      dispatch(error(types.FETCH_EXISTING_EXPORT_CONFIG_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.FETCH_EXISTING_EXPORT_CONFIG_LOADING, false));
    }
  };
};
export const getExistingImportConfig = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_EXISTING_IMPORT_CONFIG_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `ImportExportItems/GetExistingImportExportConfig/false`
      );
      dispatch(
        success(
          types.SET_EXISTING_IMPORT_CONFIG,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      dispatch(error(types.FETCH_EXISTING_IMPORT_CONFIG_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.FETCH_EXISTING_IMPORT_CONFIG_LOADING, false));
    }
  };
};
export const saveExport = config => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SAVE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'ImportExportItems/Save',
        config
      );
      if (response.data.Data.Data && config[ImportExportItemsEnum.Operation]) {
        const { FileName, FileContent } = response.data.Data.Data;
        fileDownload(
          base64ToBlob(FileContent, FileDownloadTypes.CSV),
          FileName,
          FileDownloadTypes.CSV
        );
      }
      dispatch(success(types.SAVE_SUCCESS));

      config[ImportExportItemsEnum.Operation]
        ? dispatch(getExistingExportConfig())
        : dispatch(getExistingImportConfig());
    } catch (err) {
      dispatch(error(types.SAVE_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.SAVE_LOADING, false));
    }
  };
};

export const importFormItemsData = formData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SET_IMPORT_ITEMS_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericFile(
        'ImportExportItems/ImportItems',
        formData,
        dispatch
      );
      dispatch(success(types.SET_IMPORT_ITEMS_DATA, response.data));
    } catch (ex) {
      dispatch(error(types.SET_IMPORT_ITEMS_DATA_LOADING_ERROR, ex));
    } finally {
      dispatch(resetUploadProgress());
      dispatch(loading(types.SET_IMPORT_ITEMS_DATA_LOADING, false));
    }
  };
};

export const deleteExportImport = name => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.DELETE_IMPORT_EXPORT_CONFIG_LOADING, true));
      const response = await MPWWebApi.getGeneric(
        `ImportExportItems/Delete/${name}`
      );
      dispatch(success(types.DELETE_IMPORT_EXPORT_CONFIG, response.data));
    } catch (ex) {
      dispatch(error(types.DELETE_IMPORT_EXPORT_CONFIG_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.DELETE_IMPORT_EXPORT_CONFIG_LOADING, false));
    }
  };
};
export const setImportType = () => {
  return change(
    IMPORT_ITEMS_FORM_NAME,
    ImportExportItemsEnum.Type,
    ImportExportTypeOptionsEnum.LoadPreviouslySaved
  );
};
export const setExportType = () => {
  return change(
    EXPORT_ITEMS_FORM_NAME,
    ImportExportItemsEnum.Type,
    ImportExportTypeOptionsEnum.LoadPreviouslySaved
  );
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/importExport/actions.js